import { Typography } from 'antd'
import { IndicationDetail } from 'features/indicationTriage/api/indicationTriageApi'
import { useIndicationData } from 'features/indicationTriage/IndicationContext'
import { IndicationDetailCardProps } from 'features/indicationTriage/useIndicationDetailCards'
import React, { FC, ReactNode } from 'react'

import { IndicationThicknessHistogram } from './indicationOverview/IndicationThicknessHistogram'

export const DAMAGE_MECHANISM_MAPPING: { [key: string]: string } = {
  ISOLATED_CORROSION: 'Isolated Corrosion',
  EROSION_CORROSION: 'Erosion/Corrosion',
  MICRO_PITTING: 'Micro Pitting',
  CRACKING: 'Cracking',
  HIC: 'HIC',
  SOHIC: 'SOHIC',
  SSC: 'SSC',
  SCC: 'SCC',
  HTHA: 'HTHA',
  FATIGUE_CRACKING: 'Fatigue Cracking',
  LAMINATION: 'Lamination',
  INCLUSION: 'Inclusion',
  UNKNOWN: 'Unknown',
  OTHER: 'Other',
  THINNING: 'Thinning',
  PITTING: 'Pitting',
  PLANAR_CRACK: 'Planar Crack',
  TRANSVERSE_CRACK: 'Transverse Crack',
  COLD_JOINT: 'Cold Joint',
  VOID: 'Void',
  HONEYCOMB: 'Honeycomb',
  DEBONDING: 'Debonding',
  DELAMINATION: 'Delamination',
  POROSITY: 'Porosity',
  LACK_OF_FUSION: 'Lack of Fusion',
  SLAG_INCLUSION: 'Slag Inclusion',
  CRACK: 'Crack',
  INCOMPLETE_PENETRATION: 'Incomplete Penetration',
  NOISE: 'Noise',
  GEOMETRY: 'Geometry',
  TRAILING_ECHO: 'Trailing Echo',
  MODE_CONVERSION: 'Mode Conversion',
  DEFECT: 'Defect',
}

const INDICATION_OVERVIEW_ORDERING_TUPLE_LIST: [
  string,
  (detail?: IndicationDetail) => ReactNode,
][] = [
  ['Total UT Readings', (detail) => detail?.total_ut_readings ?? ''],
  [
    'Damage Mechanism',
    (detail) => {
      if (
        detail?.damage_mechanism &&
        detail?.damage_mechanism in DAMAGE_MECHANISM_MAPPING
      ) {
        return DAMAGE_MECHANISM_MAPPING[detail.damage_mechanism]
      }
      return 'Unknown'
    },
  ],
  ['Comments', (detail) => detail?.comments ?? ''],
]

interface OverviewConfig {
  show_ref_val_on_histogram: boolean
}

const { Text } = Typography

export const Title = () => 'Indication Overview'
export const Width = '24rem'
export const CardView: FC<IndicationDetailCardProps<OverviewConfig>> = ({
  config,
}) => {
  const { indication: item } = useIndicationData()
  return (
    <div>
      <Text>Thickness</Text>
      <IndicationThicknessHistogram
        area={item?.selection}
        refValue={
          config?.show_ref_val_on_histogram
            ? item?.classificationInfo?.refVal
            : undefined
        }
      />
      <hr />
      {item?.detail ? (
        <div>
          {INDICATION_OVERVIEW_ORDERING_TUPLE_LIST.map(([label, render]) => {
            return (
              <div style={{ display: 'flex', width: '100%' }} key={label}>
                <Text strong style={{ width: '45%' }}>
                  {label}:
                </Text>

                <Text>{render(item.detail)}</Text>
              </div>
            )
          })}
        </div>
      ) : (
        <div>Detail information is currently not available</div>
      )}
    </div>
  )
}
